import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';
import { ContractLegalInvestorDocuments, PhysicalInvestorDocumentsRequest, SuitabilityTestDocumentRequest } from '../Models';

export const DocumentsAPI = (baseURL: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL,
		clientId,
		isApp: true,
		hasUnderMaintenance: false
	});

	const getPhysicalInvestorDocuments = (contractId: number): Promise<any> => {
		const serviceUrl = `/bookbuilding-api/Documents/GetPhysicalInvestorDocuments`;
		return api.get(serviceUrl, { params: { contractId } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getLegalInvestorDocuments = (contractId: number): Promise<ContractLegalInvestorDocuments> => {
		const serviceUrl = `/bookbuilding-api/Documents/GetLegalInvestorDocuments`;
		return api.get(serviceUrl, { params: { contractId } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const savePhysicalInvestorDocuments = (documents: PhysicalInvestorDocumentsRequest): Promise<any> => {
		const serviceUrl = `/bookbuilding-api/Documents/SavePhysicalInvestorDocuments`;
		return api.post(serviceUrl, documents)
		.then((response: AxiosResponse) => response.data)
		.catch((error: any) => error);
	};

	const saveLegalInvestorDocuments = (documents: ContractLegalInvestorDocuments): Promise<ContractLegalInvestorDocuments> => {
		const serviceUrl = `/bookbuilding-api/Documents/SaveLegalInvestorDocuments`;
		return api.post(serviceUrl, documents)
		.then((response: AxiosResponse) => response.data)
		.catch((error: any) => error);
	};
	
	const updatePhysicalInvestorDocuments = (documents: PhysicalInvestorDocumentsRequest): Promise<any> => {
		const serviceUrl = `/bookbuilding-api/Documents/UpdatePhysicalInvestorDocuments`;
		return api.put(serviceUrl, documents)
		.then((response: AxiosResponse) => response.data)
		.catch((error: any) => error);
	};

	const updateLegalInvestorDocuments = (documents: ContractLegalInvestorDocuments): Promise<ContractLegalInvestorDocuments> => {
		const serviceUrl = `/bookbuilding-api/Documents/UpdateLegalInvestorDocuments`;
		return api.put(serviceUrl, documents)
		.then((response: AxiosResponse) => response.data)
		.catch((error: any) => error);
	};

	const getSuitabilityTestDocument = (contractId: number): Promise<any> => {
		const serviceUrl = `/bookbuilding-api/Documents/GetSuitabilityTestDocument`;
		return api.get(serviceUrl, { params: { contractId } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const saveSuitabilityTestDocument = (documents: SuitabilityTestDocumentRequest): Promise<any> => {
		const serviceUrl = `/bookbuilding-api/Documents/SaveSuitabilityTestDocument`;
		return api.post(serviceUrl, documents)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const updateSuitabilityTestDocument = (documents: SuitabilityTestDocumentRequest): Promise<any> => {
		const serviceUrl = `/bookbuilding-api/Documents/UpdateSuitabilityTestDocument`;
		return api.put(serviceUrl, documents)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	return {
		getPhysicalInvestorDocuments,
		getLegalInvestorDocuments,
		savePhysicalInvestorDocuments,
		saveLegalInvestorDocuments,
		updatePhysicalInvestorDocuments,
		updateLegalInvestorDocuments,
		getSuitabilityTestDocument,
		saveSuitabilityTestDocument,
		updateSuitabilityTestDocument
	};
};
